export default "__VITE_ASSET__rKRMMVUn__"